import React from "react"
import flypingLogo from "../assetts/flyping.gif"

const BrandSpinner = ({ description }: { description: string }) => (
  <>
    <div className="flex items-center justify-center flex-col space-y-2 p-4">
      <img src={flypingLogo} width="100"></img>
      <p className="text-mg text-gray-500">{description}</p>
    </div>
  </>
)

export default BrandSpinner
